import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  storeContainer: (active: boolean, darkBorder: boolean) => ({
    width: '100%',
    p: 16,
    mb: active ? 0 : 16,
    gap: '2px',
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    background: 'transparent',
    border: `1px solid ${active || darkBorder ? theme.rawColors.darkGrey700 : theme.rawColors.lightGrey300}`,
    '.bold': {
      textTransform: 'uppercase'
    },
    cursor: active ? 'default' : 'pointer',
    ...reusables.mainTransition('border-color, height')
  }),
  addressContainer: {
    mb: '6px',
    height: '20px'
  },
  additionalInfo: (active: boolean) => ({
    mt: '12px',
    gap: 16,
    height: active ? '100%' : 0,
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
    ...reusables.mainTransition('height')
  }),
  buttonsContainer: () => ({
    width: '100%',
    height: '24px',
    mt: 12,
    mb: 24,
    gap: '8px',
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'left',
    alignItems: 'center',
    a: {
      button: {
        display: 'flex',
        flexDirection: 'row',
        textAlign: 'left',
        alignItems: 'center',
        pl: '10px',
        ml: '-10px',
        pr: '10px',
        '&: first-of-type': {
          borderRight: `1px solid ${theme.rawColors.lightGrey300}`
        }
      }
    }
  }),
  right: {
    width: '100%',
    textAlign: 'right'
  },
  darkGrey: {
    color: theme.rawColors.darkGrey600
  },
  lightGrey: {
    color: theme.rawColors.lightGrey700
  },
  telLink: {
    color: theme.rawColors.darkGrey700,
    textDecoration: 'underline'
  }
};